(function () {
    'use strict';

    angular.module("imApp").factory("sopClService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1849,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1850,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
